export const IS_LTI_DETERMINE =
  window.location.pathname.includes('lti/determine');

export const IS_LTI_SELECTOR =
  window.location.pathname.includes('/lti') && !IS_LTI_DETERMINE;

export const IS_LTI = IS_LTI_SELECTOR || IS_LTI_DETERMINE;

export const BASE_COURSEWORK_PATH = IS_LTI_SELECTOR
  ? '/lti/coursework'
  : IS_LTI_DETERMINE
  ? '/lti/determine/component/coursework'
  : '/coursework';
